"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Market = void 0;
const web3_js_1 = require("@solana/web3.js");
const common_1 = require("../common");
const id_1 = require("./id");
const layout_1 = require("./layout");
const logger = new common_1.Logger("Serum");
class Market {
    /* ================= static functions ================= */
    static getProgramId(version) {
        const programId = id_1.SERUM_VERSION_TO_PROGRAMID[version];
        if (!programId) {
            return logger.throwArgumentError("invalid version", "version", version);
        }
        return programId;
    }
    static getVersion(programId) {
        const programIdString = programId.toBase58();
        const version = id_1.SERUM_PROGRAMID_TO_VERSION[programIdString];
        if (!version) {
            return logger.throwArgumentError("invalid program id", "programId", programIdString);
        }
        return version;
    }
    static getStateLayout(version) {
        const STATE_LAYOUT = layout_1.MARKET_VERSION_TO_STATE_LAYOUT[version];
        if (!STATE_LAYOUT) {
            return logger.throwArgumentError("invalid version", "version", version);
        }
        return STATE_LAYOUT;
    }
    static getLayouts(version) {
        return { state: this.getStateLayout(version) };
    }
    static getAssociatedAuthority({ programId, marketId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const seeds = [marketId.toBuffer()];
            let nonce = 0;
            let publicKey;
            while (nonce < 100) {
                try {
                    // Buffer.alloc(7) nonce u64
                    const seedsWithNonce = seeds.concat(Buffer.from([nonce]), Buffer.alloc(7));
                    publicKey = yield web3_js_1.PublicKey.createProgramAddress(seedsWithNonce, programId);
                }
                catch (err) {
                    if (err instanceof TypeError) {
                        throw err;
                    }
                    nonce++;
                    continue;
                }
                return { publicKey, nonce };
            }
            return logger.throwArgumentError("unable to find a viable program address nonce", "params", {
                programId: programId.toBase58(),
                marketId: marketId.toBase58(),
            });
        });
    }
}
exports.Market = Market;
//# sourceMappingURL=serum.js.map